import { PolyIcon } from "elements";
import { useTranslation } from "utilities/i18n";

export const TestConnectionButton: React.FC<{
  onClick: () => void;
  isSubmitting: boolean;
  isValid: boolean;
  showTestSpinner: boolean;
}> = ({ onClick, isSubmitting, isValid, showTestSpinner }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className={"btn btn-secondary"}
      name={"submit"}
      onClick={onClick}
      disabled={isSubmitting || !isValid || showTestSpinner}
    >
      {!isSubmitting && showTestSpinner ? (
        <span>
          <PolyIcon icon="refresh" className="refresh spin mr-5" />
          {t("TESTING")}
        </span>
      ) : (
        t("TEST_WEBHOOK")
      )}
    </button>
  );
};
